import { useHistory } from 'react-router-dom';

function BrandCard2(props) {
  const history = useHistory();
  const { langs, prod, image } = props;

  const goBrandPage = (catename, cateID) => {
    history.push(`/machineUI/category/brand/${catename}/${cateID}`);
  };
  const name = prod.name[langs] && prod.name[langs] !== '' ? prod.name[langs] : prod.name?.en;
  return (
    <div
      className="product-card"
      onClick={() => {
        localStorage.setItem('currentCate', JSON.stringify(prod));
        goBrandPage(name, prod._id);
      }}
    >
      <img className="card-img" src={image} alt=""></img>
      <div className="card-title">{name}</div>
    </div>
  );
}
export default BrandCard2;
